<template>
<div ref="item">
  <v-card class="card fill-height">
    
    <v-card-text style="overflow-y:auto; height:180px">
      <v-layout row>
        
        <v-flex xs8>
      <v-layout column style="padding-left: 22px">
      <v-row>
      <v-tooltip :disabled="item.title.length < dispLen" bottom max-width="300">
        <template v-slot:activator="{on, attrs}">
          <div :style="{fontSize: '1.1rem',fontWeight: '600',paddingLeft: '0px', color: getPriorityColor(item.priority)}" v-on="on" v-bind="attrs" color="red">
            {{truncate(item.title)}}
          </div>
          </template>
          {{item.title}}
      </v-tooltip>
      </v-row>
      <p ></p>
      <v-row class="msg-row">
        {{item.desc}}
      </v-row>
      </v-layout>
      </v-flex>
      <v-flex xs1 />
        <v-flex xs3>
          <v-icon class="row-icon" >{{item.icon}}</v-icon>
        </v-flex>
      </v-layout>
      <v-card-actions class="card-actions">
        <v-row>
          <v-btn color="blue" @click="openWorkFlow(item)">Open</v-btn>
          <v-btn v-if="item.help" style='margin-left:10px;' color="blue" @click="openHelp(item)">Help</v-btn>
        </v-row>
      </v-card-actions>
    </v-card-text> 
  </v-card>
  </div>
</template>
<script>
import moment from 'moment'
import { sync } from "vuex-pathify"
export default {
  props: ['item', 'height', 'extra', 'displayArgs'],
  data: () => ({
    popupElem: false,
    dispLen: 24
  }),
  computed: {
    user: sync('login/loggedinUser'),
    itemHeight () {
      return this.$refs.item.clientHeight
    }
  },
  methods: {
    dateDisplay(v) {
      return moment(v).format('MM/DD/YYYY hh:mm A')
    },
    truncate(input) {
      if (input.length > this.dispLen) {
        return input.substring(0, this.dispLen) + '...';
      }
      return input;
    },
    getPriorityColor(pri) {
      if (pri == 'high') {
        return 'brown'
      } else if (pri == 'medium') {
        return 'darkGoldenRod'
      } else {
        return 'green'
      }
    },
    openWorkFlow(item) {
      console.log('Opening workflow: ', item)
      let routes = this.$router.getRoutes()
      let routeExists = false
      console.log(routes)
      routes.forEach (i => {
        if (i.name == item.component) {
          routeExists = true
          return
        }
      })
      if (!routeExists) {
        const c = () => import('@/components/workflows/' + item.component)
        let r = {
          name: item.component,
          path: '/' + item.component,
          component: c,
          props: true
        }
        this.$router.addRoute(r)
        console.log('added route for component: ', item.component)
      }
      let self = this
      setTimeout(async function() {
        try {
          let z = await self.$router.push({name: item.component, params: { args: item }})
        } catch (e) {
          console.log('caught')
          self.$root.$confirm(
            'Workflow Not Found', 
            'This workflow is either not implemented or is incorrectly configured',
            {color: "red", nocancel: true, ok: 'OK'}
          )
        }
      },1000)
    },
    openHelp(item) {
      console.log('open help file: ', item)
    }
  },
  mounted () {
    this.$emit('update:itemHeight', this.itemHeight)
  }
}
</script>
<style scoped>
.tooltip-inner {
  max-width: 300px !important;
}
.v-tooltip__content.menuable__content__active {
  opacity: 1 !important;
}
.addbutton {
  margin-left: -5px;
  padding: 5px;
  border: 1px;
  background: green;
  transition: all 0.1s ease-out;
  border-radius: 5px;
  color: white;
}
.card-actions {
  position: absolute;
  bottom: 0;
}
.row-icon {
  padding-top: 20px;
  padding-left: 40px;
  padding-right: 12px;
}
.msg-row {
  /* padding-left: 10px; */
  padding-right: 10px;
}
</style>